/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.customers.orders.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('SherpaCustomersOrdersController', ['$scope', '$state', '$filter', 'ApiService', 'HelpersService', function($scope, $state, $filter, ApiService, HelpersService) {
    $scope.sherpaCustomersOrders = {
      orders: [],
      id: '',
      type: '',
      searchQuery: '',
      searchOrderQuery: '',
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Orders'
        });
        if ($state.params.hasOwnProperty('id')) {
          $scope.sherpaCustomersOrders.id = $state.params.id;
        }
        if ($state.params.hasOwnProperty('type')) {
          $scope.sherpaCustomersOrders.type = $state.params.type;
        }

        if ($state.params.hasOwnProperty('orderNumber')) {
          $scope.sherpaCustomersOrders.searchOrderQuery = $state.params.orderNumber;
        }
        $scope.sherpaCustomersOrders.getOrders();
      },
      getOrders: function() {
        if ($scope.sherpaCustomersOrders.searchOrderQuery && $scope.sherpaCustomersOrders.searchOrderQuery !== '') {
          $scope.sherpaCustomersOrders.search();
        } else {
          if ($scope.sherpaCustomersOrders.type == 'tenant') {
            $scope.sherpaCustomersOrders.getTenantOrders();
          } else {
            $scope.sherpaCustomersOrders.getCustomerOrders();
          }
        }

      },
      getTenantOrders: function() {
        ApiService.customerService.getOrdersForTenant($scope.sherpaCustomersOrders.id).then($scope.sherpaCustomersOrders.success.getTenantOrders, $scope.sherpaCustomersOrders.error.getTenantOrders);
      },
      getCustomerOrders: function() {
        ApiService.customerService.getOrdersForVisitor($scope.sherpaCustomersOrders.id).then($scope.sherpaCustomersOrders.success.getCustomerOrders, $scope.sherpaCustomersOrders.error.getCustomerOrders);
      },

      getOrderDetail: function(row) {
        $state.go('application.sherpa.customers.ordersDetail', { id: row.entity.id, type:'tenants'});
      },

      search: function() {
        var searchQuery = $scope.sherpaCustomersOrders.searchQuery;
        var searchOrderQuery = $scope.sherpaCustomersOrders.searchOrderQuery;
        if ($scope.sherpaCustomersOrders.type === 'visitor') {
          ApiService.customerService.getOrdersForVisitorLike($scope.sherpaCustomersOrders.id, searchOrderQuery, searchQuery).then($scope.sherpaCustomersOrders.success.search, $scope.sherpaCustomersOrders.error.search);
        } else {
          ApiService.customerService.getOrdersForTenantLike($scope.sherpaCustomersOrders.id, searchOrderQuery, searchQuery).then($scope.sherpaCustomersOrders.success.search, $scope.sherpaCustomersOrders.error.search);
        }

      },
      process: function(orders) {
        var i, ii;

        for (i=0,ii=orders.length;i<ii;i++) {
          if (orders[i].discountedTotalAmount && orders[i].discountedTotalAmount > 0) {
            orders[i].adjustedAmount = $filter('currency')(orders[i].discountedTotalAmount);
          }else{
            orders[i].adjustedAmount = $filter('currency')(orders[i].totalAmount);
          }
        }

        return orders;
      },
      success: {
        getTenantOrders: function(response) {
          var self = $scope.sherpaCustomersOrders;

          self.orders = self.process(response.data.payload);
        },
        getCustomerOrders: function(response) {
          var self = $scope.sherpaCustomersOrders;

          self.orders = self.process(response.data.payload);
        },
        search: function(response) {
          var self = $scope.sherpaCustomersOrders;

          self.orders = self.process(response.data.payload);
        },
        searchOrders: function(response) {

        }
      },
      error: {
        getTenantOrders: function(response) {

        },
        getCustomerOrders: function(response) {

        },
        search: function(response) {

        },
        searchOrders: function(response) {

        }
      }
    };

    $scope.sherpaCustomersOrders.init();
    $scope.gridOptions = {
      paginate: true,
      pageSize: 50,
      multiSelect: false,
      enableRowSelection: false,
      showFooter: true,

      appScopeProvider: {
        getOrderDetail: $scope.sherpaCustomersOrders.getOrderDetail
      },

      columnDefs: [
        {
          field: 'view',
          displayName: 'View',
          onCellNavClick: function(row, col) {
            $scope.sherpaCustomersOrders.getOrderDetail(row);
          },
          cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.getOrderDetail(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.orderNumber }}</span></a></div>',
          enableSorting: false,
          enableHiding: false,
          width: 50
        },
        {
          field: 'id',
          displayName: 'ID',
          visible: false
        },
        {
          field: 'orderNumber',
          displayName: 'Order Number',
          visible: true,
          enableCellEditOnFocus: true,
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEdit: true
        },
        {
          field: 'createdOn',
          displayName: 'Order Date',
          cellFilter: 'date: "'+HelpersService.dateFormats.shortDateTime+'"',
          sort: {
            direction: 'desc'
          }
        },
        {
          field: 'email',
          displayName: 'email'
        },
        {
          field: 'contactFirstName',
          displayName: 'First Name',
          visible: true
        },
        {
          field: 'contactLastName',
          displayName: 'Last Name',
          visible: true
        },
        {
          field: 'adjustedAmount',
          displayName: 'Amount',
          visible: true
        }
      ]
    };

}]);